import React, { useRef } from 'react'
import './admin.css'
import { Button, Typography } from 'antd'

import WalletIcon from '../../assets/icons/wallet.svg';
import ChevronCircleUpIcon from '../../assets/icons/chevron-circle-up.svg';
import UserIcon from '../../assets/icons/users.svg';
import FileIcon from '../../assets/icons/file-import.svg';
import ArrowRightIcon from '../../assets/icons/arrow-right.svg';
import LilyButton from '../../components/button/lily-button';
import { useNavigate } from 'react-router-dom';
import ViewClaimDetails from '../../components/drawer/view-claim-detail';
import ClaimsList from '../../containers/claims-list/claims-list';

const DashboardPage = () => {
    const { Text, Title } = Typography;
    const navigate = useNavigate();
    const drawerDetailRef = useRef();

    const categoriesCards = [
        {
            title: "Add a Payment Method",
            description: "Set up direct deposit or paper check for faster reimbursements",
            icon: <div className='icon-bg-round'>
                <img alt='Union Icon' src={WalletIcon} />
            </div>,
            customeClass: "",
            customEle: <Button
                className='px-1'
                style={{ color: 'var(--deactivated-color)', width: 'fit-content' }}
                type="link"
                onClick={() => navigate('/setting/reimbursement-methods')}
            >
                Get Started
                <img src={ArrowRightIcon} />
            </Button>
        },
        {
            title: "Submit a Claim",
            description: "Start a new reimbursement or benefits claim in just a few steps",
            icon: <div className='icon-bg-round'>
                <img alt='Victor Icon' src={FileIcon} />
            </div>,
            customeClass: "",
            customEle: <Button
                className='px-1'
                style={{ color: 'var(--deactivated-color)', width: 'fit-content' }}
                type="link"
                onClick={() => navigate('/claims-processing/submission')}
            >
                Start Claim
                <img src={ArrowRightIcon} />
            </Button>
        },
        {
            title: "View History",
            description: "View the history of all of your pending and past claims",
            icon: <div className='icon-bg-round'>
                <img alt='Victor Icon' src={ChevronCircleUpIcon} />
            </div>,
            customeClass: "",
            customEle: <Button
                className='px-1'
                style={{ color: 'var(--deactivated-color)', width: 'fit-content' }}
                type="link"
                onClick={() => navigate('/claims-list')}
            >
                View History
                <img src={ArrowRightIcon} />
            </Button>
        },
        {
            title: "View Profile",
            description: "Ensure your contact information is up to date",
            icon: <div className='icon-bg-round'>
                <img alt='Victor Icon' src={UserIcon} />
            </div>,
            customeClass: "",
            customEle: <Button
                className='px-1'
                style={{ color: 'var(--deactivated-color)', width: 'fit-content' }}
                type="link"
                onClick={() => navigate('/user-details')}
            >
                View Details
                <img src={ArrowRightIcon} />
            </Button>
        },
    ]

    const cusTableSetting = {
        bordered: false,
        displayPagination: false,
        noPagination: true,
        locale: {
            emptyText: (
                <div className='pt-2' style={{ minHeight: '285px' }}>
                    <Text style={{ color: 'var(--deactivated-color)', fontWeight: 500 }}>
                        You don’t have any claims yet! Click “Submit a Claim” to get started.
                    </Text>
                </div>
            )
        },
        footer: () => (
            <div className='w-100 d-flex justify-content-end'>
                <Button
                    className='px-1'
                    style={{ color: 'var(--deactivated-color)', width: 'fit-content' }}
                    type="link"
                    onClick={() => navigate('/claims-list')}
                >
                    View All
                    <img src={ArrowRightIcon} />
                </Button>
            </div>
        )
    }

    const renderTableHeader = (text, isActions) => {
        return <div className='w-100 d-flex align-items-center justify-content-between'>
            <Title level={4} className='m-0'>{text || ''}</Title>
            {
                isActions && (
                    <div className='d-flex flex-row gap-2'>
                        <LilyButton
                            onClick={() => navigate('/claims-processing/submission')}
                            text='Submit a Claim'
                        />
                    </div>
                )
            }
        </div>
    }

    return (
        <div className='dashboard-layout'>
            <div className='row g-3'>
                {renderTableHeader('Recent Claims', true)}
                <div className='col-12'>
                    <ClaimsList cusTableSetting={cusTableSetting} pageSize={5} />
                </div>
            </div>
            <div className='row g-3 mt-2'>
                {renderTableHeader('Quick Actions', false)}
                {
                    categoriesCards.map((item) => {
                        return (
                            <div className={`${item.customeClass !== "" ? item.customeClass : 'col-xl-3 col-sm-6 col-12'}`}>
                                <div className='dashboard-card'>
                                    <div className='h-100 d-flex flex-column justify-content-between gap-3'>
                                        <div className='w-100 d-flex flex-column gap-3'>
                                            {item.icon || ''}
                                            <div>
                                                <Title level={5} className='mb-1' style={{ fontWeight: '500' }}>{item.title}</Title>
                                                <Text style={{ color: '#757575' }}>{item.description}</Text>
                                            </div>
                                        </div>
                                        {item.customEle || ''}
                                    </div>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
            <ViewClaimDetails ref={drawerDetailRef} />
        </div>
    )
}

export default DashboardPage